import {Link} from "react-router-dom";
import React from "react";
import plusIcon from '../assets/images/plus-white.svg';
import searchIcon from '../assets/images/search-gray.svg';
import refreshIcon from '../assets/images/refresh-gray.svg';
import sortIcon from '../assets/images/sort-gray.svg';
import downArrowIcon from '../assets/images/down-arrow-gray.svg';
import {PaginationComponent} from "./PaginationComponent";

export const ListComponent = ({
                                  title,
                                  addLink,
                                  addTitle,
                                  headerIcon,
                                  searchTerm,
                                  searchTermCallback,
                                  resetFiltersCallback,
                                  defaultSortOption,
                                  sortOptions,
                                  sortCallback,
                                  pageInfo,
                                  pageCallback,
                                  pageSizeCallback,
                                  viewMode,
                                  viewModeCallback,
                                  filterBar,
                                  children
                              }
) => {

    return (<div>
        {title && (
            <>
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-3xl font-semibold flex items-center">
                        <img src={headerIcon} className="h-8 w-8 mr-2" alt=""/>
                        {title}
                    </h1>
                    {addLink && (
                        <Link to={addLink}
                              className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md flex items-center">
                            <img src={plusIcon} className="h-5 w-5 mr-1 text-white" alt=""/>
                            Add {addTitle}
                        </Link>
                    )}
                </div>

                <div className="bg-white p-4 rounded-lg shadow mb-6 grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <img src={searchIcon} className="h-5 w-5" alt=""/>
                </div>
                <input
                    type="text"
                    className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    placeholder={`Search ${title}...`}
                    value={searchTerm}
                    onChange={(e) => searchTermCallback(e.target.value)}
                />
            </div>

            <div>
                <div className="relative">
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                        <img src={sortIcon} className="h-5 w-5" alt=""/>
                    </div>

                    <select className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white text-gray-700
                        appearance-none cursor-pointer hover:border-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500
                        sm:text-sm transition-colors duration-200"
                            value={defaultSortOption}
                            onChange={(e) => sortCallback(e.target.value)}
                    >
                        {Array.isArray(sortOptions) && sortOptions.map((sortOption) => (
                            <option key={sortOption.key} value={sortOption.key}>
                                {sortOption.value}
                            </option>
                        ))}
                    </select>

                    <div
                        className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400">
                        <img src={downArrowIcon} className="h-5 w-5" alt=""/>
                    </div>
                </div>

            </div>

            {viewModeCallback && (
                <div className="flex items-center">
                    <div className="inline-flex rounded-md shadow-sm" role="group">
                        <button
                            onClick={() => viewModeCallback('grid')}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium border border-gray-300 rounded-l-md ${
                                viewMode === 'grid' 
                                    ? 'bg-blue-50 text-blue-600 border-blue-300' 
                                    : 'bg-white text-gray-700 hover:bg-gray-50'
                            } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
                        >
                            <svg className="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                            </svg>
                            Grid
                        </button>
                        <button
                            onClick={() => viewModeCallback('list')}
                            className={`inline-flex items-center px-4 py-2 text-sm font-medium border border-gray-300 rounded-r-md ${
                                viewMode === 'list' 
                                    ? 'bg-blue-50 text-blue-600 border-blue-300' 
                                    : 'bg-white text-gray-700 hover:bg-gray-50'
                            } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
                        >
                            <svg className="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                            </svg>
                            List
                        </button>
                    </div>
                </div>
            )}

            <div className="flex justify-end">
                <button
                    onClick={resetFiltersCallback}
                    className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                    <img src={refreshIcon} className="h-5 w-5 mr-2" alt=""/>
                    Reset Filters
                </button>
            </div>
        </div>
        {filterBar}
            </>
        )}

        <div className={
            title ? (viewMode === 'list'
                ? "space-y-4"
                : "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6")
                : ""
        }>
            {children}
        </div>

        {title && React.Children.count(children) === 0 && (
            <div className="text-center py-12 bg-white rounded-lg shadow">
                <img src={headerIcon} className="mx-auto h-12 w-12" alt=""/>
                <h3 className="mt-2 text-lg font-medium text-gray-900">No {title} Found</h3>
                <p className="mt-1 text-sm text-gray-500">Get started by creating a
                    new {addTitle.toLocaleLowerCase()}.</p>
                {addLink && (
                    <div className="mt-6">
                        <Link to={addLink}
                              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                            <img src={plusIcon} className="h-5 w-5 mr-1 text-white" alt=""/>
                            Add {addTitle}
                        </Link>
                    </div>
                )}
            </div>)
        }

        {title && pageInfo && React.Children.count(children) > 0 && (
            <div className="mt-6">
                <PaginationComponent
                    pageInfo={pageInfo}
                    onPageChange={pageCallback}
                    title={title}
                    onPageSizeChange={pageSizeCallback}
                />
            </div>)}
    </div>);
}